import { FormLabel } from '@/components/form/form'

import { cn } from '@/lib/utils'

export const FormLabelWithNewBadge = ({ isNew = false, children }: { isNew?: boolean; children: React.ReactNode }) => {
  return (
    <div className={cn('flex items-center gap-x-1.5')}>
      <FormLabel className={cn('text-xs text-slate-700')}>{children}</FormLabel>
      {isNew && <NewBadge />}
    </div>
  )
}

const NewBadge = () => {
  return (
    <div
      className={cn(
        'flex items-center justify-center',
        'px-1.5 py-0.5',
        'rounded-md border border-blue-100',
        'bg-blue-50'
      )}
    >
      <span className={cn('text-xs font-semibold leading-4 text-blue-500')}>N</span>
    </div>
  )
}
